import axios from './axios-ekmtc'

const instance = axios.createInstance()
instance.defaults.baseURL = process.env.VUE_APP_USER_URL

export default instance
